import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { CommonModule } from '@angular/common';
import { AppointmentStepperService } from '../../../../services/appointment-stepper.service';
import { Appointment } from '../../../../interfaces/date-selection.interface';
import { InfoBoxComponent } from '../../../utility/info-box/info-box.component';
import { DocumentCardComponent } from '../../../document-card/document-card.component';

@Component({
    selector: 'app-summary-consultation',
    imports: [CommonModule, NzDividerModule, NzIconModule, TranslateModule, InfoBoxComponent, DocumentCardComponent],
    templateUrl: './summary-consultation.component.html',
    styleUrl: './summary-consultation.component.scss',
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SummaryConsultationComponent {
  @Input() type?: string;
  @Input() survey?: any;
  summaryData: any = {
    user: {},
    appointment: {},
    request: {},
    surveyValues: {},
    dates: [],
  };
  @Output() emitBody: EventEmitter<any> = new EventEmitter<any>();

  constructor(private appointmentStepperService: AppointmentStepperService) {}

  public ngOnInit(): void {
    this.createSummaryData();
    this.emitBody.emit(this.createBody());
  }

  private createSummaryData(): void {
    this.summaryData.user = this.appointmentStepperService.getMainUser();
    this.summaryData.appointment = this.getAppointment();
    this.summaryData.request = this.getRequest();
    this.summaryData.surveyValues = this.getSurveyValues();
    this.summaryData.dates = this.getDates();
    this.summaryData.travel = this.getTravel();
  }

  private createBody() {
    const body = {
      specialist: this.summaryData.appointment?.specialty?.description,
      specialistId: this.summaryData.appointment?.specialty?.id,
      phoneNumber: this.summaryData.user?.phone,
      fullName: this.summaryData.user?.fullName,
      message: this.summaryData.request?.reason,
      currentContactId: this.summaryData.user?.individualId,
      availabilities: this.getDatesForBody(),
      surveyValues: this.summaryData.surveyValues,
    };
    return body;
  }

  private getDatesForBody(): any[] {
    return this.summaryData.dates?.map((date: any) => {
      const [startHour, endHour] = date.time.split('-');
      const timezoneOffset = new Date(date.date).getTimezoneOffset();
      const tzSign = timezoneOffset >= 0 ? '-' : '+';
      const tzHours = this.pad(Math.floor(Math.abs(timezoneOffset) / 60));
      const tzMinutes = this.pad(Math.abs(timezoneOffset) % 60);
      return {
        start: `${date.date}T${startHour}:00${tzSign}${tzHours}:${tzMinutes}`,
        end: `${date.date}T${endHour}:00${tzSign}${tzHours}:${tzMinutes}`,
      };
    });
  }

  pad = (n: number) => n.toString().padStart(2, '0');

  private getAppointment() {
    if (this.type || this.appointmentStepperService.getSpecialistData()) {
      return {
        type: this.type ? this.type : null,
        specialty: this.appointmentStepperService.getSpecialistData()?.value?.specialistType ? this.appointmentStepperService.getSpecialistData()?.value?.specialistType : null,
      };
    }
    return null;
  }

  private getRequest() {
    if (this.appointmentStepperService.getSelectionData()) {
      return {
        topic: this.appointmentStepperService.getSelectionData()?.value?.topic,
        reason: this.appointmentStepperService.getSelectionData()?.value?.reason,
        documents: this.appointmentStepperService?.getDocuments(),
      };
    }
    return null;
  }

  private getSurveyValues() {
    if (this.appointmentStepperService.getRadioAlimentationData() && this.survey) {
      const radios = this.appointmentStepperService.getRadioAlimentationData();
      let answers: any[] = [];
      this.survey.forEach((res: any, index: any) => {
        answers.push(res.items.find((answer: any) => answer.surveyValueAnswer === radios?.value[index]));
      });
      return answers;
    }
    return null;
  }

  private getDates(): Appointment[] | null {
    if (this.appointmentStepperService.getDateSelectionData()) {
      return this.appointmentStepperService.getDateSelectionData();
    }
    return null;
  }

  private getTravel(): any | null {
    if (this.appointmentStepperService.getTravelFormData()) {
      return this.appointmentStepperService.getTravelFormData();
    }
    return null;
  }

  protected formatTimeRange(timeRange: string): string {
    const times: string[] = timeRange.split('-');
    const formattedTimes: string[] = times?.map((time: string): string => `${time}.00`);
    return formattedTimes.join('-');
  }

  public formatDate(isoDate: string): string {
    const date = new Date(isoDate);
    const day = date.getUTCDate().toString().padStart(2, '0');
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const year = date.getUTCFullYear();

    return `${day}/${month}/${year}`;
  }
}
